import stickybits from "stickybits";

stickybits('[data-provide="sticky"]', {
  noStyles: true,
  useStickyClasses: true,
});
